<script setup>
window.location.href = '/members'
</script>



<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
</route>
